import DomainSelect from 'volta/components/domain-select';
import JsonApiInfinityModel, { decorateApiQuery } from 'volta/models/jsonapi-infinity-model';
import { eqFilter, inFilter, lkFilter, niFilter } from 'volta/utils/filters-utils';

import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';
import type User from 'volta/models/user';

export default class DomainUserSelect extends DomainSelect<User, {}> {
  get idKey() {
    return 'id';
  }

  get infiniteScroll() {
    return true;
  }

  async searchPromise({ search, selected, excluded }: Record<string, any>) {
    const query: IJsonApiQuery = {
      sort: 'name'
    };
    const filter: IJsonApiQuery['filter'] = { isActive: eqFilter(true) };

    if (search && search.length) {
      filter['q'] = lkFilter(search);
    }
    if (selected && selected.length) {
      filter['selectedIds'] = inFilter(selected);
    }
    if (excluded && excluded.length) {
      filter['excludedIds'] = niFilter(excluded);
    }

    query.filter = filter;

    const decoratedQuery = this.args.beforeQuery?.(query) ?? query;

    return await this.infinity.model(
      'user',
      decorateApiQuery(decoratedQuery || query),
      JsonApiInfinityModel
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    DomainUserSelect: typeof DomainUserSelect;
    'domain-user-select': typeof DomainUserSelect;
  }
}
